<template>
  <div class="ratio-box" :style="padding">
    <div class="real-content">
      <slot />
    </div>
  </div>
</template>
<script>
// 等比盒子
export default {
  name: 'RatioBox',
  props: {
    /**
     * @description 宽高的比例
     * @example <RatioBox :ratio="16 / 9"><video style="width:100%;height:100%;" /></RatioBox>
     * */
    ratio: {
      type: Number,
      required: true,
      validator(value) {
        return value > 0
      }
    }
  },
  computed: {
    padding() {
      const yratio = (0.5 / this.ratio) * 100
      return `padding: ${yratio}% 50%`
    }
  }
}
</script>
<style lang="less" scoped>
.ratio-box {
  position: relative;
  box-sizing: content-box;
  width: 0;
  height: 0;
  & > .real-content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
